import {Button} from "@/components/mui";
import {Box, IconButton, Menu, Switch, TextField, alpha, styled} from "@mui/material";
// import AppTextField from "components/input-fields/AppTextField";

// export const StyledAppTextField = styled(AppTextField)(() => ({
//   '.MuiInputLabel-root': {
//     fontSize: '12px',
//     lineHeight: '22px',
//   },
// }));

export const StyledAppMenu = styled(Menu)(({theme}) => ({
  '.MuiPaper-root': {
    // border: `1px solid ${theme.palette.borderColor.one}`,
    '& .MuiList-root': {
      padding: '0 !important',
      backgroundColor: 'transparent !important',

    }
  },
  '.MuiListItemIcon-root': {
    // minWidth: '16px',
  }
}));

export const ModalWrapper = styled(Box)(({theme}) => ({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  padding: '16px',
  width: '520px',
  maxWidth: '100%',
  backgroundColor: theme.palette.background.default,
}));

export const StyledIconButton = styled(IconButton)(({
                                                      theme
                                                    }) => ({
  padding: 0,
  "&:hover": {
    backgroundColor: theme.palette.action.hover
  },
  color: "inherit"
}));

export const StyledRoundButton = styled(Button)(({
                                                   theme
                                                 }) => ({
  borderRadius: '100px !important'
}));

export const StyledSwitch = styled(Switch)(({theme}) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: `${theme.palette.brand.main} !important`,
    '&:hover': {
      backgroundColor: alpha(theme.palette.brand.main, theme.palette.action.hoverOpacity),
    },
    '.MuiSwitch-thumb': {
      backgroundColor: theme.palette.brand.main,
    }
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: theme.palette.brand.main,
  },
}));

export const StyledTextField = styled(TextField)(({theme}) => ({
  // ".MuiInputBase-root": {
  //   border: `solid 1px ${theme.palette.text.primary}`,
  //   borderRadius: '2px',
  //   backgroundColor: theme.palette.background.default,
  //   paddingRight: 0,
  //   height: "52px",
  //
  //   "&:hover": {
  //     ".MuiOutlinedInput-notchedOutline": {
  //       borderColor: 'rgba(255,255,255,.2) !important'
  //     }
  //   },
  //   "&.Mui-focused": {
  //     ".MuiOutlinedInput-notchedOutline": {
  //       borderColor: '#E43664 !important'
  //     }
  //   },
  // },
  // ".MuiOutlinedInput-notchedOutline": {
  //   borderColor: 'transparent !important',
  // },
  // ".MuiInputAdornment-positionEnd": {
  //   margin: '0 16px !important'
  // },
  // ".Mui-disabled": {
  //   color: "#7B7F8A",
  //   WebkitTextFillColor: "#7B7F8A !important",
  // },
  // "input": {
  //   "color": theme.palette.text.primary,
  //   "fontSize": "16px",
  //   "fontWeight": "400",
  //   "lineHeight": "20px",
  //   "padding": "16px"
  // },
  // ".MuiInputAdornment-root": {
  //   margin: 0,
  //   padding: 0,
  // },
}));